import React from 'react';
import {
  ButtonsContainer,
  TitleAndSubtitle,
  ContentButtonsWrapper,
} from '../../../layout/layout-container.styled';
import { NavButton } from '../../../nav-button/nav-button';
import { Text, font } from '../../../../style-utils/text';
import { CheckRing } from '../../../icons/check-ring';
import { OptionsInput } from '../../../styled-options/styled-options';
import { VisitorLogState } from '../../../hooks/use-visitor-log-handler';
import { DefaultComponentProps } from '../../../app-router/component-props';
import { StyledButton } from '../../../styled-button/styled-button';
import { palette } from '../../../../style-utils/theme';
import { useOptionAdvance } from '../../../hooks/use-option-advance';

export const VisitorDetails: React.FC<DefaultComponentProps> = ({
  navigate,
  state,
  changeHandler,
  options,
  nextPath,
  prevPath,
}) => {
  const { visitorDetails, preAuthorized } = state as VisitorLogState;
  const isDetailChoice = Boolean(options && options.length >= 1);
  const { pendingValue, selectAndAdvance } = useOptionAdvance({
    onSelect: value =>
      changeHandler(
        value,
        isDetailChoice ? 'visitorDetails' : 'preAuthorized',
        value
      ),
    onAdvance: () => navigate(nextPath, { replace: false }),
  });

  return (
    <>
      <TitleAndSubtitle direction="column">
        <Text as="h1" fontSize={font.size.xl} fontWeight={700} mt={0} mb={8}>
          Visitor Details
        </Text>
        <Text color={font.color.gray} fontSize={font.size.xs} mt={0} mb={0}>
          Please select one of the options below
        </Text>
      </TitleAndSubtitle>
      <ContentButtonsWrapper>
        {options && options?.length >= 1 ? (
          <OptionsInput
            options={options}
            selectedOption={visitorDetails}
            icon={<CheckRing />}
            changeHandler={changeHandler}
            changeHandlerName="visitorDetails"
            onOptionSelected={selectAndAdvance}
          />
        ) : (
          <>
            <Text fontSize={font.size.l} fontWeight={700} mt={0} mb={16}>
              Pre Authorized ?
            </Text>
            <StyledButton
              onClick={() => selectAndAdvance('Yes')}
              text={'Yes'}
              icon={<CheckRing />}
              isSelected={preAuthorized === 'Yes'}
              pending={pendingValue === 'Yes'}
            />
            <StyledButton
              onClick={() => selectAndAdvance('No')}
              text={'No'}
              icon={<CheckRing />}
              isSelected={preAuthorized === 'No'}
              pending={pendingValue === 'No'}
            />
          </>
        )}
      </ContentButtonsWrapper>
      <ButtonsContainer>
        <NavButton
          onClick={() => navigate(prevPath, { replace: false })}
          disabled={false}
          direction="back"
          textColor={palette.slate}
          background="transparent"
          text={'Back'}
        />
      </ButtonsContainer>
    </>
  );
};
